import { For, JSXElement, mergeProps } from 'solid-js';
import { DotIcon, KeyRoundIcon } from 'lucide-solid';

type MaskedSecretProps = {
  secretLength: number;
  suffix: string;
};

export default function MaskedSecret(props: MaskedSecretProps): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <div class={`flex `}>
      <KeyRoundIcon
        width={13}
        strokeWidth={1}
        class={`mr-2`}
      />
      <div class={`flex items-center`}>
        <For
          each={Array(merged.secretLength - merged.suffix.length)
            .join('.')
            .split('.')}
        >
          {() => (
            <DotIcon
              width={8}
              strokeWidth={10}
            />
          )}
        </For>
        <span class={`font-code text-sm ml-0.5`}>{merged.suffix}</span>
      </div>
    </div>
  );
}
